import { useEffect, useState } from "react";
import axios from "axios";
import { Download, FileCheck2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TenantContractHistory = ({ tenantId }) => {
  const [records, setRecords] = useState([]);
  const [open, setOpen] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    axios.get(`${API}/admin/tenants/${tenantId}/contract-acceptances`)
      .then(({ data }) => { if (active) setRecords(data); })
      .catch(() => { if (active) setError("Impossibile caricare le accettazioni"); });
    return () => { active = false; };
  }, [tenantId]);

  const download = async (record) => {
    try {
      const { data } = await axios.get(`${API}/admin/tenants/${tenantId}/contract-acceptances/${record.id}/pdf`,
        { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Contratto_Cosmely_v${record.version}_${record.id.slice(0, 8)}.pdf`;
      link.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch { toast.error("Download non riuscito"); }
  };

  return <section className="mt-6 border-t border-[#E5E5E0] pt-8" data-testid="tenant-contract-history">
    <div className="flex items-center gap-2 mb-5">
      <FileCheck2 className="w-5 h-5" strokeWidth={1.5} />
      <h2 className="font-serif text-xl">Contratti accettati</h2>
    </div>
    {error && <p role="alert" className="text-sm text-[#8C3A3A]" data-testid="tenant-contract-history-error">{error}</p>}
    {!error && records.length === 0 && <p className="text-sm text-[#707070]" data-testid="tenant-contract-history-empty">Nessuna accettazione registrata.</p>}
    {records.map((record) => <div key={record.id} className="border-b border-[#E5E5E0] py-4" data-testid={`tenant-contract-acceptance-${record.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-3 text-sm">
        <div>
          <strong>Versione {record.version} · {record.renewal_sequence ? `Rinnovo n. ${record.renewal_sequence}` : "Prima firma"}</strong>
          <p className="text-[#707070] text-xs mt-1" data-testid={`tenant-contract-accepted-at-${record.id}`}>
            {new Date(record.accepted_at).toLocaleString("it-IT")} · {record.actor_email}
          </p>
          <p className="text-[#707070] text-xs mt-1" data-testid={`tenant-contract-email-status-${record.id}`}>
            Email: {{ sent: "inviata", pending: "in attesa", processing: "in elaborazione",
                       failed: "da ritentare", dead: "da verificare" }[record.email_status] || "in preparazione"}
          </p>
        </div>
        <div className="flex gap-4">
          <button type="button" onClick={() => setOpen(open === record.id ? null : record.id)}
                  aria-expanded={open === record.id} className="underline text-xs hover:text-[#8C3A3A]"
                  data-testid={`tenant-contract-view-${record.id}`}>Visualizza testo</button>
          <button type="button" onClick={() => download(record)}
                  className="flex items-center gap-1 underline text-xs hover:text-[#8C3A3A]"
                  data-testid={`tenant-contract-pdf-${record.id}`}>
            <Download className="w-3.5 h-3.5" /> PDF
          </button>
        </div>
      </div>
      {open === record.id && <article className="prose-rt text-sm mt-5 p-5 bg-white border border-[#E5E5E0]"
        data-testid={`tenant-contract-snapshot-${record.id}`}
        dangerouslySetInnerHTML={{ __html: record.rendered_html }} />}
    </div>)}
  </section>;
};